<template>
    <div
        :class="{
            'DefaultLayout': $route.name !== 'Calculator',
            'CalculatorLayout': $route.name === 'Calculator'
        }"
    >
        <spark-docs-ad-popup v-if="state.spark_docs_ad_opened" @close="closeSparkDocsAd" />
        <s-sidebar @banner-clicked="openSparkDocsAd"></s-sidebar>

        <div id="view">
            <impersonate-panel v-if="impersonate_state.is_active" />
            <survey-panel v-if="!impersonate_state.is_active" />

            <router-view />
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, onBeforeUnmount, reactive } from 'vue'

import SSideBar from '@/common/components/SSideBar/index.vue'
import ImpersonatePanel from '@/common/components/ImpersonatePanel/index.vue'
import SurveyPanel from '@/common/components/SurveyPanel/index.vue'
import SparkDocsAdPopup from '@/common/components/banners/SparkDocsAdPopup/index.vue'

import useImpersonate from '@/common/composable/useImpersonate'
import useJiraWidget from '@/common/composable/useJiraWidget'

export default defineComponent({
    components: {
        's-sidebar': SSideBar,
        'impersonate-panel': ImpersonatePanel,
        'survey-panel': SurveyPanel,
        'spark-docs-ad-popup': SparkDocsAdPopup,
    },
    setup() {
        const state = reactive({
            spark_docs_ad_opened: false,
        })

        const { impersonate_state } = useImpersonate(false)
        const jira_widget = useJiraWidget()

        onMounted(jira_widget.install)
        onBeforeUnmount(jira_widget.destroy)

        const openSparkDocsAd = () => {
            state.spark_docs_ad_opened = true
        }

        const closeSparkDocsAd = () => {
            state.spark_docs_ad_opened = false
        }

        return { state, impersonate_state, openSparkDocsAd, closeSparkDocsAd }
    },
})
</script>
